import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart, trackInitiateCheckout } from './MetaPixel';
interface CTAButtonProps {
  text: string;
  to: string;
  fullWidth?: boolean;
  className?: string;
  isCheckoutButton?: boolean;
}
export const CTAButton = ({
  text,
  to,
  fullWidth = false,
  className = '',
  isCheckoutButton = false
}: CTAButtonProps) => {
  const location = useLocation();
  const handleClick = () => {
    // Track appropriate event based on the page and button type
    if (location.pathname === '/' || location.pathname === '/adv') {
      trackAddToCart();
    } else if (location.pathname === '/pdp' || isCheckoutButton) {
      trackInitiateCheckout();
    }
  };
  return <Link to={to} className={`inline-flex items-center justify-center bg-[#0F766E] text-white font-medium py-3 px-6 rounded-lg hover:bg-teal-800 transition-colors ${fullWidth ? 'w-full' : ''} ${className}`} onClick={handleClick} data-id="element-11">
      {text}
      <ArrowRightIcon size={18} className="ml-2" data-id="element-12" />
    </Link>;
};